import { render, staticRenderFns } from "./BulkEditing.vue?vue&type=template&id=29254622&"
import script from "./BulkEditing.vue?vue&type=script&lang=ts&"
export * from "./BulkEditing.vue?vue&type=script&lang=ts&"
import style0 from "./BulkEditing.vue?vue&type=style&index=0&id=29254622&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports